import { DiagnosisTableBean } from './VisitDocumentsDiagnosesForm.types';

export const diagnosesToText = (diagnoses: DiagnosisTableBean[]): string => {
   return diagnoses.map(({ code, name }) => `${code} ${name}`).join('\n');
};
